import Vue from 'vue'
import vuex from 'vuex'
import * as plantform from '@/common/utils/plantform';
import user from './modules/user'
import doyen from './modules/doyen'
import detail from './modules/detail'
import base from './modules/base';
Vue.use(vuex)

export default new vuex.Store({
  state: {
    plantform: plantform.system,
    isWechat: plantform.isWechat,
    encrypt: '',
    userId: '',
    isVisitor: false
  },
  mutations: {
    setUserId: (state, userId) => {
      state.userId = userId;
    }
  },
  modules: {
    user,
    doyen,
    detail,
    base
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js